import React from "react";
import { Control, Controller, FieldError } from "react-hook-form";
import Select, { StylesConfig } from "react-select";
import { LuAlertCircle, LuLayers } from "react-icons/lu";

import { useAppSelector } from "../../app/hooks";
import { getItemMaterialOptions } from "../../features/items/itemsSlice";
import { iconSelectStyles } from "../../static/styles";
import { IFormInput } from "../../types/item";
import cx from "../ui/cx";
import {
  fieldErrorTextClass,
  fieldLabelClass,
  formSelectIconClass,
} from "../ui/styles";

// The item's own material, or one sub item row's.
type MaterialPath = "material_id" | `sub_items.${number}.material_id`;

// The select sits in a third of a row, so the placeholder stays on one line like a picked value does.
const materialSelectStyles: StylesConfig = {
  ...iconSelectStyles,
  placeholder: (provided, state) => ({
    ...(iconSelectStyles.placeholder?.(provided, state) ?? provided),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};

type Props = {
  control: Control<IFormInput>;
  name: MaterialPath;
  error?: FieldError;
  idPrefix: string;
};

const ItemMaterialField = ({ control, name, error, idPrefix }: Props) => {
  const materials = useAppSelector(getItemMaterialOptions);

  const materialOptions = materials.map((material) => ({
    value: material.id,
    label: material.name,
  }));

  // The parent row decides the width.
  return (
    <div className="space-y-2">
      <label className={fieldLabelClass}>
        મટીરીયલ <span className="text-red-500">*</span>
      </label>
      <div className={cx("relative", error && "error")}>
        <LuLayers className={formSelectIconClass} />
        <Controller
          control={control}
          name={name}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              inputId={`${idPrefix}-material`}
              value={
                materialOptions.find(
                  (option) => option.value === field.value
                ) || null
              }
              options={materialOptions}
              placeholder="મટીરીયલ પસંદ કરો"
              noOptionsMessage={() => "મટીરીયલ મળ્યું નથી"}
              styles={materialSelectStyles}
              isSearchable
              className={cx("react-select-container", error && "error")}
              classNamePrefix="react-select"
              onChange={(option: any) => field.onChange(option?.value ?? null)}
            />
          )}
        />
      </div>
      {error && (
        <p className={fieldErrorTextClass}>
          <LuAlertCircle className="h-4 w-4 mr-1" />
          મટીરીયલ પસંદ કરો
        </p>
      )}
    </div>
  );
};

export default ItemMaterialField;
